import { IDetailPageData } from "../../../shared/utils/api";

export interface ICaptureBackendType {
  id: string
  name: string
  layout: string
  datamodel_id: string
  datamodel_type: string
  datamodel_name?: string
}

export function transformToBackendCapture(data: IDetailPageData): ICaptureBackendType {
  return {
    id: data.id || "",
    name: data.name || "",
    layout: JSON.stringify({
      layout: data.layout,
      layoutItems: data.layoutItems
    }),
    datamodel_id: data.datamodel_id,
    datamodel_type: data.datamodel_type
  };
}
export function transformFromBackendCapture(backendType: ICaptureBackendType) {
  return {
    id: backendType.id,
    name: backendType.name,
    layout: JSON.parse(backendType.layout),
    datamodel_id: backendType.datamodel_id,
    datamodel_type: backendType.datamodel_type,
    datamodel_name: backendType.datamodel_name
  };
}
